/*
 * @Author: Gang Jiang
 * @Date: 2026-05-25 11:08:09
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2026-05-25 14:02:00
 */
import client from './client'

function buildQuery(data) {
  return Object.keys(data)
    .filter((key) => data[key] !== undefined && data[key] !== null && data[key] !== '')
    .map((key) => `${key}=${encodeURIComponent(data[key])}`)
    .join('&')
}

export default {
  // 查询 influencer 维度的报表数据
  getInfluencerPeriods: (data) => {
    return client
      .get(`report/influencers/periods?${buildQuery(data)}`)
      .then((res) => res.data)
  },
  // 查询 advertiser 维度的报表数据
  getAdvertiserPeriods: (data) => {
    return client
      .get(`report/advertisers/periods?${buildQuery(data)}`)
      .then((res) => res.data)
  },
  // 查询 influencer 维度下各个 advertiser 的报表数据.
  getAdvertiserReportsByInflencer: (data) => {
    return client
      .get(`report/influencers/periods/advertisers?${buildQuery(data)}`)
      .then((res) => res.data)
  },
  // 查询 advertiser 维度下各个 influencer 的报表数据.
  getInfluencerReportsByAdvertiser: (data) => {
    return client
      .get(`report/advertisers/periods/influencers?${buildQuery(data)}`)
      .then((res) => res.data)
  },
  getInfluencerStatisticsData: data => {
    return client
      .get(`report/influencers/periods/total?${buildQuery(data)}`)
      .then((res) => res.data)
  },
  getAdvertiserStatisticsData: data => {
    return client
      .get(`report/advertisers/periods/total?${buildQuery(data)}`)
      .then((res) => res.data)
  }
}
